module.exports = __webpack_public_path__ + "img/Grundriss 2.OG.fe2a771e.jpg";